import TableContainer from "components/Common/DataTableContainer"
import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { cancelStallBooking, fetchStallList } from "../../../redux/actions/pvs"
import { Button } from "reactstrap"
import ConfirmPopup from "components/ConfirmPopup"
import ErrorPopup from "components/ErrorPopup"
import { CANCEL_STALL_BOOKING_RESET } from "../../../redux/types/pvs"
import { toast } from "react-toastify"
import PageLoader from "components/Common/PageLoader"

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const ViewSlotsList = () => {
  document.title = "Slots List | PULA"

  const query = useQuery()
  const bazaarId = query.get("id")

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [isOpen, setisOpen] = useState(false)
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [selectedStall, setSelectedStall] = useState(null)
  const [selectedBazaar, setselectedBazaar] = useState(null)

  const token = useSelector(state => state.auth.token)
  const stalls = useSelector(state => state.pvs.stallList)
  const bazaarList = useSelector(state => state.pvs.bazaarList)
  const cancelStallBookingScreen = useSelector(
    state => state.screens.pvs.cancelStallBooking
  )

  useEffect(() => {
    dispatch(
      fetchStallList(
        {
          enc_bazaar_id: bazaarId,
          status: "all",
        },
        token
      )
    )
  }, [])

  useEffect(() => {
    if (cancelStallBookingScreen.success) {
      toast.success(cancelStallBookingScreen.message)
      dispatch({ type: CANCEL_STALL_BOOKING_RESET })
      dispatch(
        fetchStallList(
          {
            enc_bazaar_id: bazaarId,
            status: "all",
          },
          token
        )
      )
    }
    if (cancelStallBookingScreen.error) {
      // toast.error(cancelStallBookingScreen.error)
      setIsErrorMessage(cancelStallBookingScreen.error)
      setIsErrorOpen(true)
      dispatch({ type: CANCEL_STALL_BOOKING_RESET })
    }
  }, [cancelStallBookingScreen])

  useEffect(() => {
    if (bazaarId && bazaarList && bazaarList.length > 0) {
      let currentIndex = bazaarList.findIndex(
        bazaar => bazaar.enc_bazaar_id === bazaarId
      )
      console.log("currentIndex", currentIndex)
      if (currentIndex >= 0) {
        console.log("current bazaar..", bazaarList[currentIndex])

        setselectedBazaar(bazaarList[currentIndex])
      }
    }
  }, [bazaarId, bazaarList])

  const columns = useMemo(
    () => [
      // {
      //   header: "Bazaar Name",
      //   accessorKey: "bazaar_name",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      {
        header: "Stall Number",
        accessorKey: "stall_number",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Stall Type",
        accessorKey: "stall_type",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Stall Size",
      //   accessorKey: "stall_size",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      {
        header: "Base Price",
        accessorKey: "base_price",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Two Sided Price",
        accessorKey: "two_sides_price",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Stall Cost",
        accessorKey: "stall_cost",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "GST",
        accessorKey: "gst",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "stall_status",
        enableColumnFilter: false,
        enableSorting: true,
        sortingFn: (rowA, rowB, columnId) => {
          const order = {
            available: 0,
            booked: 1,
          }

          const a = String(rowA.getValue(columnId) || "").toLowerCase()
          const b = String(rowB.getValue(columnId) || "").toLowerCase()

          const aRank = order[a] !== undefined ? order[a] : 99
          const bRank = order[b] !== undefined ? order[b] : 99

          return aRank - bRank
        },
        cell: info => {
          const status = info.getValue()
          return (
            <span
              className={`badge ${
                status === "Booked"
                  ? "bg-success"
                  : status === "Available"
                  ? "bg-warning"
                  : "bg-danger"
              }`}
            >
              {status}
            </span>
          )
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const row = info.row.original
          return row.stall_status === "Available" ? (
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-primary"
                onClick={() =>
                  navigate(`/edit-slots?id=${info.row.original.enc_stall_id}`)
                }
              >
                Edit
              </button>
            </div>
          ) : (
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-light"
                onClick={() => {
                  setSelectedStall(row)
                  setisOpen(true)
                }}
              >
                Cancel Booking
              </button>
            </div>
          )
        },
      },
    ],
    [navigate]
  )

  const cancelBooking = () => {
    setisOpen(false)
    dispatch(
      cancelStallBooking({ enc_stall_id: selectedStall.enc_stall_id }, token)
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* <div className="mb-3"></div>
        <h4 className="h4 mb-0 nom-title">View Slots List</h4> */}
        <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-0 nom-title">{`${
              selectedBazaar?.bazaar_name || ""
            } Slots`}</h4>
          </div>
          <Button
            color="primary"
            onClick={() => {
              navigate("/add-slots", { state: { enc_bazaar_id: bazaarId } })
            }}
          >
            Add Slot
          </Button>
        </div>
        <TableContainer
          defaultPageSize={20}
          initialSorting={[{ id: "stall_status", desc: false }]}
          columns={columns}
          data={stalls || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          buttonClass="btn btn-primary"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
      <ConfirmPopup
        title="Confirm"
        isOpen={isOpen}
        message={"Are you sure you want to delete this slot booking?"}
        onConfirm={cancelBooking}
        confirmText="Yes"
        cancelText="No"
        toggle={() => {
          setisOpen(!isOpen)
        }}
      />
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Booking Cancellation Failed"
        message={isErrorMessage}
      />
      <PageLoader open={cancelStallBookingScreen.loading} />
    </div>
  )
}

export default ViewSlotsList
